module.exports = __webpack_public_path__ + "static/media/intro_mob_png-sep-2026.fff5cb63.png";